import { useState } from 'react';

export default function Button({children, onClick, className, disabled, tooltip}) {
    const [showTooltip, setShowTooltip] = useState(false);
    const classNameContainBackground = className?.includes('bg-');
    const classNameContainText= className?.includes('text-');

    console.log(tooltip, showTooltip);
    
    return (
        <div className="relative inline-block">
             
            <button 
                disabled={disabled} 
                onClick={onClick} 
                onMouseEnter={() => tooltip && setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                className={`${disabled ? 'opacity-50' : ''} ${!classNameContainBackground ? 'bg-neatcar' : ''} ${!classNameContainText ? 'text-white' : ''} px-4 py-2 rounded-md ${className ?? ''}`}
            >
                {children}
            </button>
           {tooltip && showTooltip && (
                <div className="absolute z-50 px-2 py-1 text-sm text-gray-200 bg-gray-900/50 border border-gray-900 rounded-md shadow-lg whitespace-nowrap -top-12 left-1/2 transform -translate-x-1/2">
                    {tooltip}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-300"></div>
                </div>
            )}
        </div>
    )
}